type TDashedDividerProps = {
    className?: string;
    withCircle?: boolean;
};

export const DashedDivider = ({ className, withCircle }: TDashedDividerProps) => (
    <div
        className={`relative flex w-full max-w-full items-center justify-between gap-7 md:gap-10 ${className} ${
            withCircle
                ? 'before:absolute before:left-0 before:h-5 before:w-5 before:-translate-x-1/2 before:rounded-full before:bg-white before:content-[""] after:absolute after:right-0 after:h-5 after:w-5 after:translate-x-1/2 after:rounded-full after:bg-white after:content-[""] dark:before:bg-dark-3 dark:after:bg-dark-3 md:before:h-7 md:before:w-7 md:after:h-7 md:after:w-7'
                : ''
        }`}
    >
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="h-0 w-1/5 border border-white dark:border-dark-3" />
        <div className="hidden h-0 w-1/5 border border-white dark:border-dark-3 md:block" />
        <div className="hidden h-0 w-1/5 border border-white dark:border-dark-3 md:block" />
    </div>
);
